import firebase from 'firebase/app';
import { Position,  Intent, Toaster } from "@blueprintjs/core";

const AppToaster = Toaster.create({
    className: "value-prop",
    position: Position.TOP,
});

const showToast = () => {
    AppToaster.show({ message: "Template Added", intent: Intent.PRIMARY, timeout: 1000});
}


export const AddTemplate = ( setShowTempMod, temp, tempName, profile ) => {
    firebase
    .firestore()
    .collection('organizations')
    .doc(profile.company)
    .collection('valueProps')
    .doc()
    .set({
        Template: temp,
        Title: tempName,
        CreatedBy: profile.email,
        ContextType: 'template',
    }).then(
        setShowTempMod(false),
        showToast(),
    )
}